import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../../components/states';
// import { useTranslation } from 'react-i18next';
import ContentModuleForm from '../../../../components/forms/ContentModuleForm';
import Loader from '../../../../components/Loader';
import { useFetch } from '../../../../hooks/useFetch';

export default function ContentsModulesEditPage() {
  // const { t } = useTranslation();
  const { itemId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/classes/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <ContentModuleForm defaultValues={data?.data} /> : <Loader />;
}
